(function () {
  var sections = document.querySelectorAll("[data-reviews-section]");
  if (!sections.length) return;
  sections.forEach(initReviewsSection);

  function initReviewsSection(sectionEl) {
    var slidesSource = sectionEl.dataset.slidesSource || "api";
    var sliderEl = sectionEl.querySelector("[data-reviews-swiper]");
    var wrapperEl = sliderEl ? sliderEl.querySelector(".swiper-wrapper") : null;
    var navEl = sectionEl.querySelector("[data-reviews-nav]");

    if (!sliderEl || !wrapperEl) return;

    if (slidesSource === "custom") {
      if (!wrapperEl.children.length) {
        setSectionState(sectionEl, "empty");
        if (navEl) navEl.classList.add("reviews__nav--hidden");
      } else {
        clearSectionState(sectionEl);
        initSwiper(sectionEl, sliderEl);
      }
      return;
    }

    var starIcon = sectionEl.dataset.starIcon || "";
    var maxReviews = parseInt(sectionEl.dataset.maxReviews, 10) || 12;
    var minRating = parseInt(sectionEl.dataset.minRating, 10) || 0;
    var photosOnly = sectionEl.dataset.photosOnly === "true";
    var token = (sectionEl.dataset.judgemeToken || "").trim();
    var shopDomain = (sectionEl.dataset.shopDomain || "").trim();

    var metafieldEl = sectionEl.querySelector("[data-judgeme-html]");
    var metafieldHtml = metafieldEl ? metafieldEl.innerHTML : "";
    if (metafieldEl) metafieldEl.remove();

    if (!token || !shopDomain) {
      useMetafieldFallback(sectionEl, wrapperEl, navEl, sliderEl, metafieldHtml, minRating, photosOnly, maxReviews, starIcon);
      return;
    }

    setSectionState(sectionEl, "loading");

    fetchReviewsJSON(shopDomain, token)
      .then(function (reviews) {
        var filtered = filterReviews(reviews, minRating, photosOnly).slice(0, maxReviews);

        if (filtered.length) {
          renderSlides(sectionEl, wrapperEl, navEl, sliderEl, filtered, starIcon);
        } else {
          useMetafieldFallback(sectionEl, wrapperEl, navEl, sliderEl, metafieldHtml, minRating, photosOnly, maxReviews, starIcon);
        }
      })
      .catch(function () {
        useMetafieldFallback(sectionEl, wrapperEl, navEl, sliderEl, metafieldHtml, minRating, photosOnly, maxReviews, starIcon);
      });
  }

  function useMetafieldFallback(sectionEl, wrapperEl, navEl, sliderEl, html, minRating, photosOnly, maxReviews, starIcon) {
    if (html) {
      var parsed = parseReviewsFromHtml(html);
      var filtered = filterReviews(parsed, minRating, photosOnly).slice(0, maxReviews);

      if (filtered.length) {
        renderSlides(sectionEl, wrapperEl, navEl, sliderEl, filtered, starIcon);
        return;
      }
    }
    setSectionState(sectionEl, "empty");
    if (navEl) navEl.classList.add("reviews__nav--hidden");
  }

  // ---------- API: fetch JSON reviews from multiple strategies ----------

  function fetchReviewsJSON(shopDomain, token) {
    return tryRestAPI(shopDomain, token)
      .catch(function () {
        return tryWidgetAPI(shopDomain, token);
      });
  }

  function tryRestAPI(shopDomain, token) {
    var allReviews = [];

    function fetchPage(page) {
      var url =
        "https://judge.me/api/v1/reviews" +
        "?api_token=" + encodeURIComponent(token) +
        "&shop_domain=" + encodeURIComponent(shopDomain) +
        "&per_page=100&page=" + page;

      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error("REST API " + res.status);

        return res.json().then(function (data) {
          var reviews = data.reviews || [];

          reviews.forEach(function (r) {
            if (!r.hidden && r.curated !== "spam") {
              allReviews.push({
                body: r.body || "",
                rating: parseInt(r.rating, 10) || 5,
                reviewer: { name: (r.reviewer && r.reviewer.name) || "Customer" },
                product_title: r.product_title || "",
                pictures: r.pictures || [],
                hidden: !!r.hidden,
              });
            }
          });

          if (reviews.length >= 100 && page < 10) {
            return fetchPage(page + 1);
          }

          return allReviews;
        });
      });
    }

    return fetchPage(1);
  }

  function tryWidgetAPI(shopDomain, token) {
    var endpoints = [
      "https://judge.me/api/v1/widgets/all_reviews_page",
      "https://judge.me/api/v1/widgets/reviews_tab",
      "https://judge.me/api/v1/widgets/featured_carousel",
    ];

    var allReviews = [];

    function tryNext(idx) {
      if (idx >= endpoints.length) {
        if (allReviews.length) return Promise.resolve(allReviews);
        return Promise.reject(new Error("All widget endpoints exhausted"));
      }

      return fetchWidgetPages(endpoints[idx], shopDomain, token)
        .then(function (reviews) {
          if (reviews.length) {
            allReviews = allReviews.concat(reviews);
            return allReviews;
          }
          return tryNext(idx + 1);
        })
        .catch(function () {
          return tryNext(idx + 1);
        });
    }

    return tryNext(0);
  }

  function fetchWidgetPages(baseUrl, shopDomain, token) {
    var allReviews = [];

    function fetchPage(page) {
      var url =
        baseUrl +
        "?shop_domain=" + encodeURIComponent(shopDomain) +
        "&api_token=" + encodeURIComponent(token) +
        "&per_page=50&page=" + page;

      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error("Widget " + res.status);

        return res.text().then(function (text) {
          var html = "";
          try {
            var json = JSON.parse(text);
            html = json.widget || json.html || json.all_reviews || json.reviews_tab || json.featured_carousel || json.body || "";
            if (!html) {
              for (var k in json) {
                if (typeof json[k] === "string" && json[k].length > 100) {
                  html = json[k];
                  break;
                }
              }
            }
          } catch (e) {
            html = text;
          }

          var reviews = parseReviewsFromHtml(html);

          if (reviews.length) {
            allReviews = allReviews.concat(reviews);
          }

          if (reviews.length >= 10 && page < 10) {
            return fetchPage(page + 1);
          }

          return allReviews;
        });
      });
    }

    return fetchPage(1);
  }

  // ---------- Filtering ----------

  function filterReviews(reviews, minRating, photosOnly) {
    return reviews.filter(function (review) {
      if (review.hidden) return false;
      if (minRating > 0 && (parseInt(review.rating, 10) || 0) < minRating) return false;
      if (photosOnly && !hasPhoto(review)) return false;
      return true;
    });
  }

  function hasPhoto(review) {
    if (!review.pictures || !review.pictures.length) return false;
    for (var i = 0; i < review.pictures.length; i++) {
      var pic = review.pictures[i];
      if (!pic) continue;
      if (pic.urls) {
        var url = pic.urls.compact || pic.urls.small || pic.urls.original || "";
        if (url) return true;
      }
      if (typeof pic === "string" && pic) return true;
    }
    return false;
  }

  // ---------- HTML parsing (for widget / metafield fallback) ----------

  function parseReviewsFromHtml(html) {
    if (!html || !html.trim()) return [];

    var temp = document.createElement("div");
    temp.innerHTML = html;
    var reviews = [];

    var selectors = [
      ".jdgm-rev",
      ".jdgm-carousel-item",
      "[data-review-id]",
      ".jdgm-rev-widg__review",
      ".jdgm-all-reviews__review",
    ];

    for (var i = 0; i < selectors.length; i++) {
      var items = temp.querySelectorAll(selectors[i]);
      if (items.length) {
        items.forEach(function (item) {
          var parsed = parseOneReview(item);
          if (parsed) reviews.push(parsed);
        });
        if (reviews.length) return reviews;
      }
    }
    return reviews;
  }

  function isHiddenReview(el) {
    var cls = el.className || "";
    if (cls.indexOf("jdgm--hidden") !== -1 || cls.indexOf("jdgm-hidden") !== -1) return true;
    var style = el.getAttribute("style") || "";
    if (style.indexOf("display:none") !== -1 || style.indexOf("display: none") !== -1) return true;
    return false;
  }

  function parseOneReview(el) {
    if (isHiddenReview(el)) return null;

    var body = extractText(el, [
      ".jdgm-rev__body",
      ".jdgm-carousel-item__review-body",
      ".jdgm-carousel-item__review",
      ".jdgm-rev__content",
    ]);

    var author = extractText(el, [
      ".jdgm-rev__author",
      ".jdgm-carousel-item__reviewer-name",
      ".jdgm-rev__author-name",
    ]) || "Customer";

    var product = extractText(el, [
      ".jdgm-rev__prod-link",
      ".jdgm-rev__product-link",
      ".jdgm-carousel-item__product-title",
      ".jdgm-carousel-item__review-title",
    ]) || el.getAttribute("data-product-title") || "";

    var rating = extractRating(el);

    var pictureUrl = extractImage(el, [
      ".jdgm-rev__pic-img",
      ".jdgm-rev__pics img",
      ".jdgm-rev__pic-link img",
      ".jdgm-carousel-item__picture img",
      ".jdgm-carousel-item img",
    ]);

    if (!body && author === "Customer") return null;

    return {
      body: body,
      rating: rating,
      reviewer: { name: author },
      product_title: product,
      pictures: pictureUrl
        ? [{ hidden: false, urls: { compact: pictureUrl, small: pictureUrl, original: pictureUrl } }]
        : [],
      hidden: false,
    };
  }

  function extractText(container, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = container.querySelector(selectors[i]);
      if (el) {
        var text = el.textContent.trim();
        if (text) return text;
      }
    }
    return "";
  }

  function extractRating(el) {
    var ratingEl = el.querySelector(".jdgm-rev__rating, .jdgm-carousel-item__review-rating");
    if (ratingEl) {
      var score = parseInt(ratingEl.getAttribute("data-score"), 10);
      if (score) return score;
      var onStars = ratingEl.querySelectorAll(".jdgm-star.jdgm--on, .jdgm--on");
      if (onStars.length) return onStars.length;
    }
    var dataScore = parseInt(el.getAttribute("data-score"), 10);
    if (dataScore) return dataScore;
    return 5;
  }

  function extractImage(container, selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = container.querySelector(selectors[i]);
      if (el) {
        var src = el.getAttribute("src") || el.getAttribute("data-src") || "";
        if (src && src.indexOf("data:") !== 0) return src;
      }
    }
    return "";
  }

  // ---------- Rendering ----------

  function renderSlides(sectionEl, wrapperEl, navEl, sliderEl, reviews, starIcon) {
    wrapperEl.innerHTML = "";
    reviews.forEach(function (review) {
      wrapperEl.appendChild(buildSlide(review, starIcon));
    });
    clearSectionState(sectionEl);
    initSwiper(sectionEl, sliderEl);
  }

  function initSwiper(sectionEl, sliderEl) {
    if (typeof Swiper === "undefined") return;
    new Swiper(sliderEl, {
      slidesPerView: "auto",
      spaceBetween: 20,
      watchOverflow: true,
      navigation: {
        nextEl: sectionEl.querySelector("[data-reviews-next]"),
        prevEl: sectionEl.querySelector("[data-reviews-prev]"),
      },
      breakpoints: {
        0: { spaceBetween: 12 },
        769: { spaceBetween: 20 },
      },
    });
  }

  // ---------- Slide building ----------

  function buildSlide(review, starIcon) {
    var slide = createEl("div", "swiper-slide reviews__slide");
    var card = createEl("article", "reviews__card");
    var cardBody = createEl("div", "reviews__card-body");
    var cardContent = createEl("div", "reviews__card-content");
    var cardDetails = createEl("div", "reviews__card-details");
    var pictureUrl = getReviewPicture(review);
    var productTitle = review.product_title || "";
    var reviewerName = (review.reviewer && review.reviewer.name) || "Customer";
    var rating = parseInt(review.rating, 10) || 5;

    cardContent.appendChild(buildStars(rating, starIcon));
    cardDetails.appendChild(buildQuote(review.body));
    cardDetails.appendChild(buildAuthor(reviewerName, productTitle));
    cardContent.appendChild(cardDetails);
    cardBody.appendChild(cardContent);

    if (pictureUrl) {
      cardBody.appendChild(buildMedia(pictureUrl, productTitle));
    } else {
      card.classList.add("reviews__card--no-media");
    }

    card.appendChild(cardBody);
    slide.appendChild(card);
    return slide;
  }

  function buildStars(rating, starIcon) {
    var stars = createEl("div", "reviews__stars");
    stars.setAttribute("aria-label", rating + " out of 5 stars");
    for (var i = 0; i < rating; i++) {
      var star = document.createElement("img");
      star.src = starIcon;
      star.alt = "";
      star.width = 25;
      star.height = 25;
      stars.appendChild(star);
    }
    return stars;
  }

  function buildQuote(text) {
    var quote = createEl("div", "reviews__quote");
    quote.textContent = normalizeReviewText(text);
    return quote;
  }

  function buildAuthor(name, productTitle) {
    var author = createEl("div", "reviews__author");
    var authorMain = createEl("div", "reviews__author-main");
    var avatar = createEl("span", "reviews__avatar", getInitial(name));
    var authorName = createEl("span", "reviews__author-name", name);
    authorMain.appendChild(avatar);
    authorMain.appendChild(authorName);
    author.appendChild(authorMain);
    if (productTitle) {
      author.appendChild(createEl("span", "reviews__author-sep", "/"));
      author.appendChild(createEl("span", "reviews__author-product", productTitle));
    }
    return author;
  }

  function buildMedia(url, altText) {
    var media = createEl("div", "reviews__card-media");
    var image = document.createElement("img");
    image.src = upgradeImageUrl(url);
    image.alt = altText || "";
    image.loading = "lazy";
    media.appendChild(image);
    return media;
  }

  function getReviewPicture(review) {
    if (!review || !Array.isArray(review.pictures) || !review.pictures.length) return "";
    for (var i = 0; i < review.pictures.length; i++) {
      var item = review.pictures[i];
      if (item && item.hidden !== true && item.urls) {
        var raw =
          item.urls.huge ||
          item.urls.large ||
          item.urls.original ||
          item.urls.small ||
          item.urls.compact ||
          "";
        if (raw) return upgradeImageUrl(raw);
      }
    }
    return "";
  }

  // Judge.me CDN resizes via ?width= even on __original.jpeg — strip query to get full image.
  function upgradeImageUrl(url) {
    if (!url) return "";
    return String(url).split("?")[0];
  }

  function normalizeReviewText(text) {
    var value = (text || "").trim();
    if (!value) return "";
    if (
      (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"') ||
      (value.charAt(0) === "\u201c" && value.charAt(value.length - 1) === "\u201d")
    ) {
      return value;
    }
    return "\u201c" + value + "\u201d";
  }

  function getInitial(name) {
    return (name || "C").trim().charAt(0).toUpperCase();
  }

  function createEl(tag, className, text) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (text != null) el.textContent = text;
    return el;
  }

  function setSectionState(sectionEl, state) {
    sectionEl.classList.remove("reviews--loading", "reviews--empty", "reviews--error");
    sectionEl.classList.add("reviews--" + state);
  }

  function clearSectionState(sectionEl) {
    sectionEl.classList.remove("reviews--loading", "reviews--empty", "reviews--error");
  }
})();
